import type { FunctionComponent } from 'react'
import React from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'

import type { TaxonomyHierarchyWithCounts } from '../../../../generated/frontend'
import { Link } from '../../../../shared/components/Link'
import { usePaths } from '../../../../shared/hooks/usePaths'
import styles from './CategoryListingLinks.module.scss'

export const CategoryListingLinks: FunctionComponent<Props> = ({ taxonomyHierarchyWithCounts }) => {
  const { subVerticalPath } = usePaths()

  if (!taxonomyHierarchyWithCounts?.categories?.length) {
    return null
  }

  const sortedCategories = [...taxonomyHierarchyWithCounts.categories].sort((a, b) =>
    a.name.localeCompare(b.name)
  )

  return (
    <nav aria-labelledby="category-listing-links-header">
      <Typography
        id="category-listing-links-header"
        tag="h2"
        textStyle="sb-text-body-default-strong"
        className={styles.header}
      >
        All categories in {taxonomyHierarchyWithCounts.name} news:
      </Typography>
      <ul className={styles.linkList}>
        {sortedCategories.map(({ slug, name }) => (
          <li className={styles.linkItem} key={slug}>
            <Link href={`${subVerticalPath}/${slug}`}>{name}</Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  taxonomyHierarchyWithCounts: TaxonomyHierarchyWithCounts
}
